import uniq from './uniq';

const includesDuplicates = array => array.length !== uniq(array).length;

export default includesDuplicates;
